import { MenuSeparator } from "@skbkontur/react-ui";
import React from "react";
import { Kebab, MenuItem } from "react-ui";

import { Icon } from "../../Icons/Icon";
import { PropsPageActions } from "../Unit/Types";

interface MenuKebabProps {
    onAddInstance?: () => void;
    addButtonName?: string;
    onCopyInstance?: () => Promise<void>;
    onClearInstance?: () => void;
    onRemoveInstance?: () => void;
    tid?: string;
    pageActions?: PropsPageActions;
}

export const MenuKebab = (props: MenuKebabProps) => {
    const hasAddInstance = !!props.onAddInstance;
    const hasCopyInstance = !props.pageActions?.actions?.copy?.hideAction && !!props.onCopyInstance;
    const hasClearInstance = !props.pageActions?.actions?.clear?.hideAction && !!props.onClearInstance;
    const hasRemoveInstance = !props.pageActions?.actions?.remove?.hideAction && !!props.onRemoveInstance;
    const isMenuSeparatorActive = (hasAddInstance || hasCopyInstance) && (hasClearInstance || hasRemoveInstance);
    const hasSome = hasAddInstance || hasCopyInstance || hasClearInstance || hasRemoveInstance;

    if (!hasSome) {
        return <></>;
    }

    return (
        <Kebab data-tid={props.tid ?? "KebabMenu"} disableAnimations>
            {hasAddInstance && (
                <MenuItem
                    data-tid={"row-menu-add-previous"}
                    icon={<Icon name="PlusIcon" />}
                    onClick={props.onAddInstance}>
                    <span>{props.addButtonName ? props.addButtonName : "Добавить"}</span>
                </MenuItem>
            )}
            {hasCopyInstance && (
                <MenuItem data-tid="row-menu-copy" icon={<Icon name="CopyIcon" />} onClick={props.onCopyInstance}>
                    {"Копировать"}
                </MenuItem>
            )}
            {isMenuSeparatorActive && <MenuSeparator />}
            {hasClearInstance && (
                <MenuItem data-tid="row-menu-clear" icon={<Icon name="DocXIcon" />} onClick={props.onClearInstance}>
                    {"Очистить"}
                </MenuItem>
            )}
            {hasRemoveInstance && (
                <MenuItem data-tid="row-menu-remove" icon={<Icon name="XIcon" />} onClick={props.onRemoveInstance}>
                    {"Удалить"}
                </MenuItem>
            )}
        </Kebab>
    );
};
